// extracted by extract-css-chunks-webpack-plugin
module.exports = {"vote":"vote-qrJKx0qG","voted":"voted-3um1QTPb"};